module.exports = __webpack_public_path__ + "img/closeBlack.8268492.svg";